module.exports = __webpack_public_path__ + "img/logo.37649c34.png";